const OwnedEarned = Object.freeze({
  OWNED: 'Owned',
  EARNED: 'Earned',
  PARTNERED: 'Partnered'
})
export default OwnedEarned
export type OwnedEarnedStrings = typeof OwnedEarned[keyof typeof OwnedEarned]
// RESERVE BELOW
